<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>推广达人编号：</label>
                <el-input v-model="search_Obj.f_member_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>姓名：</label>
                <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>手机号：</label>
                <el-input v-model="search_Obj.f_cellphone" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>结算状态：</label>
                <el-select v-model="search_Obj.f_settled_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('settled_state')" :key="'settled_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>结算批次：</label>
                <el-input v-model="search_Obj.f_settled_batch" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>订单号：</label>
                <el-input v-model="search_Obj.f_sn" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>订单状态：</label>
                <el-select v-model="search_Obj.f_status" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('order_status')" :key="'order_status'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="member_code" label="推广达人编号" sortable="custom" width="140"></el-table-column>
                <el-table-column prop="name" label="姓名" sortable="custom"></el-table-column>
                <el-table-column prop="cellphone" label="手机号" sortable="custom"></el-table-column>
                <el-table-column prop="settled_state" label="结算状态" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.settled_state, "settled_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="settled_batch" label="结算批次" sortable="custom"></el-table-column>
                <el-table-column prop="sn" label="订单编号" sortable="custom"></el-table-column>
                <el-table-column prop="status" label="订单状态" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.status, "order_status") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="paytime" label="支付时间" sortable="custom"></el-table-column>
                <el-table-column prop="pay_price" label="订单金额" sortable="custom"></el-table-column>
                <el-table-column prop="commission" label="佣金" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看推广订单"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'promotionOrderList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '推广订单',
            menu_id: 7700,
            list_url: "/api/admin/promotionorder/list",
            search_Obj: {
                f_member_code: '',
                f_name: '',
                f_cellphone: '',
                f_settled_batch: '',
                f_settled_state: '',
                f_sn: '',
                f_status: '',
            },
            del_Obj:{
                url:'/api/admin/promotionorder/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['order_status', 'settled_state'],
        };
    },
    methods: {}
};
</script>